import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, UserService, NotificationService } from 'yt-ng-framework';
import { DokumentStavka } from './dokument-stavka';
import { ActivatedRoute, Router } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-dokument-stavka-update',
  templateUrl: './dokument-stavka-update.component.html'
})
export class DokumentStavkaUpdateComponent 
extends BaseUpdateComponent<DokumentStavka>
implements OnInit {

  ukupnoUlaz: number=0;
  ukupnoIzlaz: number=0;
  ukupnoRazlika: number=0;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    public userService: UserService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('ValutaID', Validators.required, 'required', 'DOKUMENTSTAVKA.VALUTAID.VALIDATION.REQUIRED');
      this.baseFormGroup.get('ValutaID').valueChanges.subscribe(val => {
        if (this.Parameters.get(0).get(0).Value == 'I'){
          let datum: NgbDate = new NgbDate(this.Parameters.get(1).get(0).Value["year"], this.Parameters.get(1).get(0).Value["month"], this.Parameters.get(1).get(0).Value["day"]);
          let valutaID = this.baseFormGroup.get('ValutaID').value;
          this.baseDataService.GetData('XchDokumentStavka', 'GetUkupanUlazByDatum', {'Datum': datum, 'ValutaID': valutaID })
          .subscribe(data => {
            this.ukupnoUlaz = Number(data);
            this.ukupnoRazlika=this.ukupnoUlaz-this.ukupnoIzlaz;
         })
      }
      });
    this.onChange();

    // this.addValidatorToFc('IznosValute', Validators.required, 'required', 'DOKUMENTSTAVKA.IZNOSVALUTE.VALIDATION.REQUIRED');
    // this.addValidatorToFc('IznosPoKursuTrans', Validators.required, 'required', 'DOKUMENTSTAVKA.IZNOSPOKURSUTRANS.VALIDATION.REQUIRED');
    // this.addValidatorToFc('IznosPoSrednjemKursu', Validators.required, 'required', 'DOKUMENTSTAVKA.IZNOSPOSREDNJEMKURSU.VALIDATION.REQUIRED');
    // if(this.parameters[0].Value == 'U'){
    //   this.addValidatorToFc('PocetnoStanje', Validators.required, 'required', 'DOKUMENTSTAVKA.POCETNOSTANJE.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('KupovinaOdBanke', Validators.required, 'required', 'DOKUMENTSTAVKA.KUPOVINAODBANKE.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('UlazSaDeviznogRacuna', Validators.required, 'required', 'DOKUMENTSTAVKA.ULAZSADEVIZNOGRACUNA.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('InterniUlaz', Validators.required, 'required', 'DOKUMENTSTAVKA.INTERNIULAZ.VALIDATION.REQUIRED');
    // }
    // if(this.parameters[0].Value == 'I'){
    //   this.addValidatorToFc('Zamena', Validators.required, 'required', 'DOKUMENTSTAVKA.ZAMENA.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('InterniIzlaz', Validators.required, 'required', 'DOKUMENTSTAVKA.INTERNIIZLAZ.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('IzlazNaDevizniRacun', Validators.required, 'required', 'DOKUMENTSTAVKA.IZLAZNADEVIZNIRACUN.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('ProdajaBanci', Validators.required, 'required', 'DOKUMENTSTAVKA.PRODAJABANCI.VALIDATION.REQUIRED');
    //   this.addValidatorToFc('ProdajaBanciObavezi', Validators.required, 'required', 'DOKUMENTSTAVKA.PRODAJABANCIOBAVEZI.VALIDATION.REQUIRED');
    // }
  }

  onChange(): void {
    this.baseFormGroup.valueChanges.subscribe(val => {
      if (this.Parameters.get(0).get(0).Value == 'U'){
        this.ukupnoUlaz=Number(val.PocetnoStanje)
          +Number(val.InterniUlaz)
          +Number(val.InterniUlazPlatUsl)
          +Number(val.KupovinaOdBanke)
          +Number(val.UlazSaDeviznogRacuna)
          +Number(val.IznosValute);
      }
      this.ukupnoIzlaz = 0;
      if (this.Parameters.get(0).get(0).Value == 'I'){
        this.ukupnoIzlaz=Number(val.IznosValute)
          +Number(val.Zamena)
          +Number(val.InterniIzlaz)
          +Number(val.IzlazNaDevizniRacun)
          +Number(val.ProdajaBanci)
          +Number(val.ProdajaBanciObavezi)  
          +Number(val.InterniIzlazEvraPlatUsl);
        }
      this.ukupnoRazlika=this.ukupnoUlaz-this.ukupnoIzlaz;
    });    
  
  }

  onValutaSelect(){
      if (this.Item.ID == -1 && this.Parameters.get(0).get(0).Value == 'U'){
      //let dateNow = new Date();
      // let datum: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate()-1);
      let datum: NgbDate = new NgbDate(this.Parameters.get(1).get(0).Value["year"], this.Parameters.get(1).get(0).Value["month"], this.Parameters.get(1).get(0).Value["day"]);
      let valutaID = this.baseFormGroup.get('ValutaID').value;
      this.baseDataService.GetData('XchDokumentStavka', 'GetOtkupPSByDatum', {'Datum': datum, 'ValutaID': valutaID })
          .subscribe(data => {
          this.baseFormGroup.patchValue({ PocetnoStanje: data });
          this.baseFormGroup.get('PocetnoStanje').updateValueAndValidity();
      })
      // this.baseDataService.GetData('XchDokumentStavka', 'GetUkupanUlazByDatum', {'Datum': datum, 'ValutaID': valutaID })
      // .subscribe(data => {
      //   this.ukupnoUlaz = Number(data);
      // });
    }
  }
}
